import React from 'react'
import {MemberCircleExclamationIcon} from './Bases/MemberCircleExclamationIcon'
import {Color} from '../../Styles'

export const MemberErrorExclamationIcon: React.VFC = () => {
  return <MemberCircleExclamationIcon size={'xl'} color={Color.Red500} mr={'8px'}/>
}
